// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blinking-icon {
  animation: blinkFade 1s infinite ease-in-out;
}

@keyframes blinkFade {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./src/components/Live_Tracking/DummyComponents.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;AAC9C;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB","sourcesContent":[".blinking-icon {\n  animation: blinkFade 1s infinite ease-in-out;\n}\n\n@keyframes blinkFade {\n  0% { opacity: 1; }\n  50% { opacity: 0; }\n  100% { opacity: 1; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
